import { pluralize } from '@belong/common';
import { IconArrowDown } from '@belong/icons';
import { Image, Text, LinkBase } from '@belong/ui';
import { STRINGS } from 'action-items/strings';
import { clsx } from 'clsx';
import css from './action-item-count-link.module.css';

type Props = {
  count: number;
  propertyId?: string;
};

export function ActionItemCountLink({ count, propertyId }: Props) {
  if (count === 0) {
    return null;
  }

  return (
    <LinkBase
      href={`/accounts/portfolio/action-items/${propertyId}`}
      className="flex items-center justify-between"
    >
      <div className="flex items-center gap-xs uppercase text-red">
        <Image
          alt=""
          className="h-md w-md object-scale-down"
          src="icons/alert-red.svg"
        />
        <Text fontWeight="semibold">{`${count} ${pluralize(count, STRINGS.actionItem)}`}</Text>
      </div>
      <IconArrowDown className={clsx('h-2sm', css.arrow)} />
    </LinkBase>
  );
}
